// ImageMessage.js
import React from 'react';
import Image from './MessageTypes/Image';
import Time from './Time';

const ImageMessage = ({ src, time, senderType, caption, selectedColor }) => {
  return (
    <div
      className={`flex flex-col mb-2 ${
        senderType === 'user' ? 'items-end' : 'items-start'
      }`}
    >
      <div
        className={`text-sm p-2 break-words rounded-tl-2xl rounded-tr-2xl max-w-[75%] md:max-w-[50%] lg:max-w-[70%] ${
          senderType === 'user'
            ? 'text-white rounded-bl-2xl'
            : 'bg-callbell-light-gray text-black rounded-br-2xl'
        }`}
        style={{ backgroundColor: senderType === 'user' ? selectedColor : '' }}
      >
        <Image src={src} />
        <div className="pt-1">{caption}</div>
      </div>
      <Time time={time} senderType={senderType} />
    </div>
  );
};

export default ImageMessage;
